import { render, staticRenderFns } from "./AddPrivateFormulationToCustomerPopUp.vue?vue&type=template&id=3cf8a2cf&scoped=true&"
import script from "./AddPrivateFormulationToCustomerPopUp.vue?vue&type=script&lang=js&"
export * from "./AddPrivateFormulationToCustomerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddPrivateFormulationToCustomerPopUp.vue?vue&type=style&index=0&id=3cf8a2cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf8a2cf",
  null
  
)

export default component.exports